import type { CreateCustomAudienceFormValues } from "./types";

export function createCustomAudienceFormDefaults(): CreateCustomAudienceFormValues {
  return {
    name: "",
    genres: [],
    artists: [],
    segment: null,
    segment_size: undefined,
    createLookalike: false,
    type: "kyd",
    lookalike: {
      name: "",
      ratio: undefined,
    },
  };
}
